import ajv, {type Ajv as Ajv6Type, type ErrorObject as ErrorObject6, type Options as Options6} from '@wix/dm-ajv-6'
import Ajv8 from '@wix/dm-ajv'
import _ from 'lodash'

export {ErrorObject6, Options6, Ajv6Type}

type Ajv8Type = InstanceType<typeof Ajv8.Ajv>

export {Ajv8Type}

const createInstance = (
    ajvOptions: any = {},
    useAjv8: boolean = false,
    formats: Options6['formats'] = {}
): Ajv6Type | Ajv8Type => {
    if (!useAjv8) {
        return ajv(ajvOptions)
    }
    const instance = new Ajv8.Ajv2019(ajvOptions as any)
    Ajv8.formats(instance)
    _.forEach(formats, (formatSchema, formatName) => {
        instance.addFormat(formatName, formatSchema)
    })
    return instance
}

export {createInstance}
